import { useState, useContext } from 'react'
import { ModalContext } from '../ModalContext'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function TextAreaActionModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const [isLoading, setIsLoading] = useState(false)
    const [textValue, setTextValue] = useState(modalData.textAreaInitialValue ?? '')

    const OnActionButtonClicked = async () => {

        setIsLoading(true)
        
        await modalData.buttonAction(textValue)

        setIsLoading(false)
        
        HideModal()
    }

    return (
        <>
            <div className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-orange-400">
                <ExclamationTriangleIcon className="h-8 w-8 text-white" aria-hidden="true" />
            </div>

            <div className="text-center text-lg font-semibold leading-6 text-gray-900">{modalData.titleText}</div>

            <div className="space-y-2">
                {modalData.bodyText.map((text, index) => (
                    <p key={index} className="text-sm text-gray-600">
                        {text}
                    </p>
                ))}
            </div>

            <div>
                <textarea
                    name="textAreaActionInput"
                    id="textAreaActionInput"
                    className="h-32 w-full py-2 px-4 text-sm rounded-xl border border-gray-400 bg-gray-100 placeholder:text-gray-400"
                    placeholder={modalData.textAreaPlaceholder ?? ''}
                    value={textValue}
                    onChange={(event) => setTextValue(event.target.value)}
                />
            </div>

            <BrandColorButton
                text={modalData.buttonText}
                action={OnActionButtonClicked}
                isLoading={isLoading}
            />
        </>
    )
}
